export default __webpack_public_path__ + "static/media/basmati-rice.6652db18.jpg";